import { i18n } from 'i18n';

export const CATEGORIES = () => ({
	credit_cards: i18n.t('Кредитные карты'),
	debit_cards: i18n.t('Дебетовые карты'),
	loans: i18n.t('Кредиты'),
	insurance: i18n.t('Страхование'),
	microfinance: i18n.t('МФО'),
	deposits: i18n.t('Вклады'),
	for_business: i18n.t('Для бизнеса'),
	other: i18n.t('Другое'),
});
